/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit One/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function One({
  children,
  viewPath = "/App/ChooseLocation/ParentCompanies/Content/One"
  
}) {
  return null
}